// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__1b6wU","active":"pagination_active__PsFhf","loading":"pagination_loading__3MeKE","paginationNumbers":"pagination_paginationNumbers__2rWmP"};